import React from "react"
import MultiCarousel from "react-multi-carousel"
import "react-multi-carousel/lib/styles.css"
import PropTypes from "prop-types"
import {
  addressCarousel,
  addressCarouselItem,
  addressImg,
  addressImgSolo,
  carouselLightBoxOpener,
} from "./carousel.module.scss"
import { useBuildData } from "gatsby-theme-blank/src/hooks/use-build-data"
import {
  LightBoxCarouselOpener,
  LightBoxImage,
} from "../LightBoxImage/light-box-image"

//-----------------------Parent Component---------------------------//

const Carousel = ({ address }) => {
  const options = {
    buttons: {
      backgroundColor:
        useBuildData().theme_settings.palette.b_color_gradients.b_dark,
      showAutoplayButton: false,
      showCloseButton: true,
      showDownloadButton: false,
      showFullscreenButton: true,
      showNextButton: false,
      showPrevButton: false,
      showThumbnailsButton: false,
    },
  }

  if (address.relationships.field_image_adresse.length === 1) {
    return (
      <div className={addressImgSolo}>
        <LightBoxImage
          type={"node"}
          node={{
            alt: address.relationships.field_image_adresse[0].localFile.alt,
            file: address.relationships.field_image_adresse[0].localFile,
          }}
        />
      </div>
    )
  }
  return <MyCarousel address={address} options={options} />
}

//-----------------------Parent Component---------------------------//

//-----------------------Child Component---------------------------//

const MyCarousel = ({ address, options }) => {
  const responsive = {
    desktop: {
      breakpoint: { max: 3000, min: 600 },
      items: 1,
    },
    mobile: {
      breakpoint: { max: 600, min: 0 },
      items: 1,
    },
  }
  const lightBoxImages = []
  address.relationships.field_image_adresse.forEach((img) => {
    lightBoxImages.push({
      type: "node",
      alt: "Bannière " + img.filename,
      src: img.localFile.SlugifiedPublicUrl,
    })
  })
  return (
    <div className={addressCarousel}>
      <LightBoxCarouselOpener
        images={lightBoxImages}
        className={carouselLightBoxOpener}
      />
      <MultiCarousel
        className={addressCarouselItem}
        transitionDuration={500}
        autoPlay={true}
        responsive={responsive}
        autoPlaySpeed={5000}
        infinite={true}
        arrows={true}
        dots={true}
      >
        {address.relationships.field_image_adresse.map((img) => {
          return (
            <div className={addressImg} key={address.drupal_id}>
              <img alt={img.filename} src={img.localFile.SlugifiedPublicUrl} />
            </div>
          )
        })}
      </MultiCarousel>
    </div>
  )
}

//-----------------------Child Component---------------------------//

//-----------------------Prop-Types---------------------------//

Carousel.propTypes = {
  address: PropTypes.object.isRequired,
}
MyCarousel.propTypes = {
  address: PropTypes.object.isRequired,
  options: PropTypes.object.isRequired,
}
//-----------------------Prop-Types---------------------------//

export default Carousel
